import { GET_ALL_USER_ROLES, UPDATE_USER_ROLES_PENDING } from '../constants';

export default {
  [GET_ALL_USER_ROLES](state, data) {
    state.list = data.data.data;
  },
  [UPDATE_USER_ROLES_PENDING](state, data) {
    state.pending = data;
  }
};
